import React from 'react';
import styles from './WorkWithUs.module.scss';
import Reveal from 'react-awesome-reveal';
import { flipFromLeft } from '../Animation/Animation';
import { Typography } from '../Typography';
import { Button } from '../Button';

const WorkWithUs = () => {
  return (
    <div className={styles.workWithUsSection}>
      <div className={styles.workWithUsContainer}>
        <div className={styles.workWithUsCard}>
          <Reveal keyframes={flipFromLeft} duration={1000} delay={100} triggerOnce>
            <Typography
              variant="display-md"
              as="h2"
              color="grayDark-50"
              weight="semibold"
              className={styles.workWithUsTitle}
            >
              Work With Us
            </Typography>
            <Typography
              variant="text-xl"
              color="grayDark-600"
              className={styles.workWithUsDescription}
            >
              Whether you are developing a new video product, optimizing an existing pipeline, or
              exploring custom technical solutions, EPEN is ready to help.
            </Typography>
          </Reveal>
          <Button
            label="Get in touch to start a conversation"
            onClick={() => {
              window.location.href = '/contact-us';
            }}
            variant="primary"
          ></Button>
        </div>
      </div>
    </div>
  );
};

export default WorkWithUs;
